$('.home-banner-block-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 5000,        // <- no delay
  speed: 600,             // <- smooth transition speed
  arrows: true,
  dots: false,
  pauseOnHover: false,
});

document.querySelector('.cc-chat-block.cc-offline')?.addEventListener('click', function() {
  if (!window.GorgiasChat) {
    console.warn('Gorgias Chat not loaded yet');
    return;
  }

  // Check if chat is open
  const isOpen = window.GorgiasChat.isOpen && window.GorgiasChat.isOpen();

  if (isOpen) {
    window.GorgiasChat.close();  // close if open
  } else {
    window.GorgiasChat.open();   // open if closed
  }
});


$('.bough-title').on('click', function() {
  $('.also-bought-product').slideToggle(300);
});


